import React, { useState,useEffect } from "react"
import { Table, Button, DatePicker, Space, Tag, Modal, Select, Input, message } from "antd"
import { CalendarOutlined } from "@ant-design/icons"
import { useNavigate } from "react-router-dom"
import dayjs from "dayjs"
import LogBookHeader from "./LogBookHeader"
import { saveAs } from 'file-saver';
import LogBookLoginRequired from "../../hooks/LogBookLoginRequired"
 
const { RangePicker } = DatePicker
const { Option } = Select
const { TextArea } = Input
 
const ViewEntries = () => {
  const ExcelJS = require('exceljs');
  const [checkInDate, setCheckInDate] = useState(null)
  const [isSuperAdmin,setSuperAdmin]=useState(false);
  const [checkOutDate, setCheckOutDate] = useState(null)
  const [filteredEntries, setFilteredEntries] = useState([])
  const [visitorEntries, setVisitorEntries] = useState([])
  const [selectedEmployee, setSelectedEmployee] = useState(null)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [statusFilter, setStatusFilter] = useState(["ACTIVE"]) // Changed to array with default ACTIVE
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [isCancelModalVisible, setIsCancelModalVisible] = useState(false)
  const [cancelReason, setCancelReason] = useState("")
  const [selectedIdsForCancel, setSelectedIdsForCancel] = useState([])
  const [selectedNamesForCancel, setSelectedNamesForCancel] = useState([])
  const navigate = useNavigate()

  const role=localStorage.getItem("role")
  const isSuperUser = role === "SUPERUSER"

 
  
  // Function to sort entries by date and time (newest first)
  const sortEntriesByDateTime = (entries) => {
    return [...entries].sort((a, b) => {
      const dateTimeA = dayjs(`${a.date} ${a.inTime}`, "YYYY-MM-DD HH:mm")
      const dateTimeB = dayjs(`${b.date} ${b.inTime}`, "YYYY-MM-DD HH:mm")
      return dateTimeB.valueOf() - dateTimeA.valueOf() // Descending order (newest first)
    })
  }

  // Function to filter entries by multiple statuses
  const filterEntriesByStatus = (entries, statuses) => {
    if (!isSuperUser || !statuses || statuses.length === 0) return entries
    return entries.filter(entry => statuses.includes(entry.status))
  }
 
  useEffect(() => {
    const fetchEntries = async () => {
      try {
        const response = await fetch('https://techsolutionsservice.ustdev.com/logbook/api', {
          headers: {
            // 'Authorization': `Bearer ${localStorage.getItem("token")}`,
          }
        });
 
        const result = await response.json();
        if (response.ok && result.success && result.data) {
          const sortedEntries = sortEntriesByDateTime(result.data);
          setVisitorEntries(sortedEntries);
          
          // For super user, show only ACTIVE status on initial load
          // For other users, show all entries
          if (isSuperUser) {
            const activeEntries = filterEntriesByStatus(sortedEntries, ["ACTIVE"]);
            setFilteredEntries(activeEntries);
          } else {
            setFilteredEntries(sortedEntries);
          }
        } else {
          console.error('Error fetching entries:', result.message || 'Unknown error');
        }
      } catch (error) {
        console.error('API error fetching visitor entries:', error);
      }
    };
 
    fetchEntries();
  }, []); // Only run on component mount
 
  const handleEmployeeClick = (employee) => {
    console.log(employee)
    // Navigate to edit entry page with employee data
    navigate(`/logbook/edit-employee/${employee.id}`)
  }
 
  const handleModalClose = () => {
    setIsModalVisible(false)
    setSelectedEmployee(null)
  }

  const handleStatusFilterChange = (value) => {
    setStatusFilter(value)
  }

  // Handle checkbox selection
  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys)
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    type: 'checkbox',
    getCheckboxProps: (record) => ({
      disabled: record.status === 'COMPLETED' || record.status === 'CANCELLED',
      name: record.visitorName,
    }),
  }
  
  function handleExcel() {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Visitors');
    console.log("download Started");
    
  
    if (!filteredEntries || filteredEntries.length === 0) {
      console.warn('No data to export.');
      return;
    }
  
    const rows = filteredEntries.map(emp => ({
      VisitorType: emp.visitorType,
      VisitorID: emp.visitorId || '',
      VisitorName: emp.visitorName,
      PurposeOfVisit: emp.purposeOfVisit,
      PhoneNumber: emp.phoneNumber,
      Email: emp.email,
      Date: emp.date,
      InTime: emp.inTime,
      OutTime: emp.outTime || '',
      Facility: emp.facility,
      RequesedBy:emp.requestedBy,
      onBehalfOf:emp.onBehalfOf,
      Status: emp.status,
      ApprovedBy: emp.authorizedSignatory || '',
      CancellationReason: emp.cancellationReason || ''
    }));
  
    // Define worksheet columns
    worksheet.columns = Object.keys(rows[0]).map(key => ({
      header: key,
      key: key,
      width: 25,
    }));
    worksheet.getRow(1).font={bold:true}
    // Add all rows
    worksheet.addRows(rows);
  
    // Generate Excel and trigger download using FileSaver
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      saveAs(blob, 'visitors-export.xlsx');
    }).catch(error => {
      console.error('Error generating Excel file:', error);
    });
  }
  

  // Handle cancel button click
  const handleCancelClick = () => {
    if (selectedRowKeys.length === 0) {
      message.warning('Please select at least one entry to cancel')
      return
    }

    // Get the selected entries and extract appropriate IDs
    const selectedEntries = filteredEntries.filter(entry => {
      const rowKey = entry.visitorId || entry._id || entry.id
      return selectedRowKeys.includes(rowKey)
    })
        const idsForCancel = selectedEntries.map(entry => {
      if (entry.visitorType?.toLowerCase() === 'employee') {
        return entry.visitorId
      } else {
        return entry._id || entry.id
      }
    })
    const namesForCancel = selectedEntries.map(entry => ({
      name: entry.visitorName,
      type: entry.visitorType,
      id: entry.visitorType?.toLowerCase() === 'employee' ? entry.visitorId : (entry._id || entry.id)
    }))
    setSelectedIdsForCancel(idsForCancel)
    setSelectedNamesForCancel(namesForCancel)
    setIsCancelModalVisible(true)
  }
  const handleCancelConfirm = async () => {
    if (!cancelReason.trim()) {
      alert('Please provide a reason for cancellation')
      message.error('Please provide a reason for cancellation')
      return
    }

    try {
      const response = await fetch('https://techsolutionsservice.ustdev.com/api/logbook/cancel', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          ids: selectedIdsForCancel,
          reason: cancelReason
        })
      })

      const result = await response.json()
      
      if (response.ok) {
        message.success('Entries cancelled successfully')
        setIsCancelModalVisible(false)
        setCancelReason('')
        setSelectedRowKeys([])
        setSelectedIdsForCancel([])
        setSelectedNamesForCancel([])
         window.location.reload() 

      } else {
        message.error(result.message || 'Failed to cancel entries')
      }
    } catch (error) {
      console.error('Error cancelling entries:', error)
      message.error('Failed to cancel entries')
    }
  }
  const handleCancelModalClose = () => {
    setIsCancelModalVisible(false)
    setCancelReason('')
    setSelectedIdsForCancel([])
    setSelectedNamesForCancel([])
  }
 
  const columns = [
    { title: "Employee ID", dataIndex: "visitorId", key: "visitorId" },
    { title: "Visitor Type", dataIndex: "visitorType", key: "visitorType" },
    {
      title: "Visitor Name",
      dataIndex: "visitorName",
      key: "visitorName",
      render: (text, record) => (
        <span
          onClick={() => handleEmployeeClick(record)}
          style={{
            color: '#1890ff',
            cursor: 'pointer',
            textDecoration: 'underline'
          }}
          onMouseEnter={(e) => e.target.style.color = '#40a9ff'}
          onMouseLeave={(e) => e.target.style.color = '#1890ff'}
        >
          {text}
        </span>
      )
    },
    { title: "Date", dataIndex: "date", key: "date" },
    { title: "In Time", dataIndex: "inTime", key: "inTime" },
    { title: "Out Time", dataIndex: "outTime", key: "outTime" },
    {title:"Requested By",dataIndex:"requestedBy",key:"requestedBy"},
    {title:"On Behalf of",dataIndex:"onBehalfOf",key:"onBehalfOf"},
    {title:"Approved By",dataIndex:"authorizedSignatory",key:"authorizedSignatory"},
    { title: "Purpose", dataIndex: "purposeOfVisit", key: "purposeOfVisit" },
    { title: "Facility", dataIndex: "facility", key: "facility" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "APPROVED" ? "blue" : status === "COMPLETED" ? "green" : status === "ACTIVE" ? "orange" : "yellow"}>{status}</Tag>
      ),
    },
  ]
 
  const handleApplyFilters = () => {
    let entriesToFilter = visitorEntries

    if (isSuperUser && statusFilter) {

      entriesToFilter = filterEntriesByStatus(entriesToFilter, statusFilter)
    }
    if (checkInDate && checkOutDate) {
      entriesToFilter = entriesToFilter.filter((entry) => {
        const entryDateTime = dayjs(`${entry.date} ${entry.inTime}`, "YYYY-MM-DD HH:mm")
        return entryDateTime.isAfter(checkInDate) && entryDateTime.isBefore(checkOutDate)
      })
    }

    if (isSuperUser && statusFilter && (!checkInDate || !checkOutDate)) {

      entriesToFilter = filterEntriesByStatus(visitorEntries, statusFilter)
    }
    const sortedFiltered = sortEntriesByDateTime(entriesToFilter)
    console.log("Filtered:", sortedFiltered)
    setFilteredEntries(sortedFiltered)
    setSelectedRowKeys([])
  }
 
  const handleAddNewEntry = () => {
    navigate("/employee-process-management")
  }
  if(localStorage.getItem('isLogBookLoggedIn') !== 'true'){
    LogBookLoginRequired();
  }
  return (
    <div>
      <div className="container mx-auto py-6 max-w-7xl">
        <h1 className="text-2xl font-bold text-center mb-6">VIEW ENTRIES</h1>
 
        <div className="bg-gray-50 p-6 rounded shadow mb-8 max-w-screen-xl mx-auto w-full">
          <h2 className="text-lg font-semibold mb-4">Filter Option</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            {isSuperUser && (
              <Space direction="vertical" className="w-full">
                <label>Status</label>
                <Select
                  mode="multiple"
                  value={statusFilter}
                  onChange={handleStatusFilterChange}
                  className="w-full rounder border"
                  placeholder="Select Status(es)"
                  allowClear
                >
                  <Option value="ACTIVE">Active</Option>
                  <Option value="APPROVED">Approved</Option>
                  <Option value="COMPLETED">Completed</Option>
                  <Option value="CANCELLED">Cancelled</Option>

                </Select>
              </Space>
            )}
            
            <Space direction="vertical" className={`w-full ${isSuperUser ? '' : 'md:col-span-2'}`}>
              <label>Date & Time Range</label>
              <RangePicker
                showTime={{ format: "HH:mm" }}
                className="w-full"
                onChange={(values) => {
                  setCheckInDate(values?.[0] || null)
                  setCheckOutDate(values?.[1] || null)
                }}
                suffixIcon={<CalendarOutlined />}
              />
            </Space>
          </div>
          <div className="flex justify-center mt-4">
            <Button
              type="button"
              onClick={handleApplyFilters}
              className="bg-slate-700 hover:bg-slate-800 text-white font-medium py-2 px-8 rounded-full focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-opacity-50 transition-colors">
              Filter
            </Button>
          </div>
        </div>
 
        <div className="overflow-x-auto mb-6">
          <style>
            {`
              .ant-table-thead > tr > th {
                background-color: #334155 !important;
                color: white !important;
                font-weight: 600 !important;
                border-bottom: 1px solid #475569 !important;
                text-align: center !important;
              }
              .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
                background-color: #475569 !important;
              }
            `}
          </style>
          {
isSuperUser &&
         
          <div className="flex justify-end mb-5">
  <Button
    className="text-white"
    style={{ background: "#183D5D",color:"#fffff",width:"auto"}}
    onClick={handleExcel}
    disabled={!visitorEntries || visitorEntries.length === 0}
  >
    Download Excel
  </Button>
</div>
 }
          <Table
            columns={columns}
            dataSource={filteredEntries}
            pagination={{
              pageSize: 5,
              hideOnSinglePage: true,
              showSizeChanger: false, 
              showQuickJumper: false,
            }}
            className="border-x-2 border-b-2 rounded border-white-100"
            bordered
            rowSelection={rowSelection}
            rowKey={(record) => {
              const key = record.visitorId || record._id || record.id
              return key
            }}
          />
        </div>

        {/* Cancel Button */}
        <div className="flex justify-center mb-4 mb-10">
          <Button
            type="button"
            onClick={handleCancelClick}
            disabled={selectedRowKeys.length === 0}
            className="bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-8 rounded-full focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed">
            Cancel Selected ({selectedRowKeys.length})
          </Button>
        </div>
 
        {/* <div className="flex justify-center mb-12">
          <Button
           type="button"
           onClick={handleAddNewEntry}
           className="bg-slate-700 hover:bg-slate-800 text-white font-medium py-2 px-8 rounded-full focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-opacity-50 transition-colors">
            Add New Entry
          </Button>
        </div> */}

         {/* Cancel Confirmation Modal */}
         <Modal
          title="Cancel Selected Entries"
          open={isCancelModalVisible}
          onCancel={handleCancelModalClose}
          footer={[
            <Button key="cancel" onClick={handleCancelModalClose}>
              Close
            </Button>,
            <Button
              key="confirm"
              type="primary"
              danger
              onClick={handleCancelConfirm}
              loading={false}
            >
              Confirm Cancel
            </Button>
          ]}
          width={600}
        >
          <div className="space-y-4">
            <div>
              <p className="mb-2"><strong>Selected entries for cancellation:</strong></p>
              <div className="bg-gray-100 p-3 rounded">
                {selectedNamesForCancel.map((entry, index) => (
                  <div key={index} className="mb-2 p-2 bg-white rounded border">
                    <div className="flex justify-between items-center">
                      <span className="font-medium">{entry.name}</span>
                      <Tag color={entry.type?.toLowerCase() === 'employee' ? 'blue' : 'green'}>
                        {entry.type}
                      </Tag>
                    </div>
                  </div>
                ))}
              </div>
            </div>
           
            <div>
              <label className="block mb-2 font-medium">
                Reason for cancellation: <span className="text-red-500">*</span>
              </label>
              <TextArea
                rows={4}
                value={cancelReason}
                onChange={(e) => setCancelReason(e.target.value)}
                placeholder="Please provide a reason for cancelling these entries..."
                className="w-full"
              />
            </div>
          </div>
        </Modal>
 
        {/* Employee Details Modal */}
        <Modal
          title="Employee Details"
          open={isModalVisible}
          onCancel={handleModalClose}
          footer={[
            <Button key="close" onClick={handleModalClose}>
              Close
            </Button>
          ]}
          width={600}
        >
          {selectedEmployee && (
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <strong>Employee ID:</strong> {selectedEmployee.visitorId}
                </div>
                <div>
                  <strong>Visitor Type:</strong> {selectedEmployee.visitorType}
                </div>
                <div>
                  <strong>Visitor Name:</strong> {selectedEmployee.visitorName}
                </div>
                <div>
                  <strong>Date:</strong> {selectedEmployee.date}
                </div>
                <div>
                  <strong>In Time:</strong> {selectedEmployee.inTime}
                </div>
                <div>
                  <strong>Out Time:</strong> {selectedEmployee.outTime}
                </div>
                <div>
                  <strong>Purpose:</strong> {selectedEmployee.purposeOfVisit}
                </div>
                <div>
                  <strong>Facility:</strong> {selectedEmployee.facility}
                </div>
                <div>
                  <strong>Phone Number:</strong> {selectedEmployee.phoneNumber}
                </div>
                <div>
                  <strong>Email:</strong> {selectedEmployee.email}
                </div>
                <div>
                  <strong>Status:</strong>
                  <Tag color={selectedEmployee.status === "APPROVED" ? "blue" : selectedEmployee.status === "COMPLETED" ? "green" : selectedEmployee.status === "ACTIVE" ? "orange" : "yellow"} className="ml-2">
                    {selectedEmployee.status}
                  </Tag>
                </div>
              </div>
            </div>
          )}
        </Modal>
      </div>
    </div>
  )
}
 
export default ViewEntries